import { Game } from './components/ZombieGame/Game';

function App() {
  return (
    <div className="w-full h-screen bg-black">
      <Game />
    </div>
  );
}

export default App;
